import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';

export function SortColumnIcon({ sorted }: Readonly<{ sorted: false | 'asc' | 'desc' }>) {
  if (sorted === 'desc') return <ArrowDown className="size-3.5" />;
  if (sorted === 'asc') return <ArrowUp className="size-3.5" />;
  return <ChevronsUpDown className="size-3.5 opacity-50" />;
}
